//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/colors/lightBlue.js
var e = {
	50: "#e1f5fe",
	100: "#b3e5fc",
	200: "#81d4fa",
	300: "#4fc3f7",
	400: "#29b6f6",
	500: "#03a9f4",
	600: "#039be5",
	700: "#0288d1",
	800: "#0277bd",
	900: "#01579b",
	A100: "#80d8ff",
	A200: "#40c4ff",
	A400: "#00b0ff",
	A700: "#0091ea"
};
//#endregion
export { e as default };

//# sourceMappingURL=index87.js.map